import type { OnInit, PipeTransform } from '@angular/core';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, Pipe } from '@angular/core';
// TODO: Fix enforce-module-boundaries errors
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OverviewVideoModuleVideo } from '@candyland/generic/tt-com-shared-overviews';

@Component({
  selector: 'nmo-video-container-v2',
  templateUrl: './video-container-v2.component.html',
  styleUrls: ['./video-container-v2.component.scss'],
})
export class VideoContainerV2Component implements OnInit {
  @Input() groups: OverviewVideoModuleVideo[][];
  @Input() defaultVideo: OverviewVideoModuleVideo;
  @Output() groupChange: EventEmitter<number> = new EventEmitter<GroupIndex>();
  selectedVideo: OverviewVideoModuleVideo;
  iframeVisible = false;
  currentSlideIndex = 0;

  constructor(private changeDetection: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.selectedVideo = this.defaultVideo;
  }

  selectVideo(gi, ii): void {
    this.selectedVideo = this.groups[gi][ii];
  }

  toggleThumb(): void {
    this.iframeVisible = true;
    this.changeDetection.detectChanges();
  }

  slideChanged(gi: GroupIndex): void {
    this.currentSlideIndex = gi;
    this.groupChange.emit(gi);
  }

  groupTrackBy(index: number): number {
    return index;
  }
}

@Pipe({ name: 'decodeHtmlString' })
export class DecodeHtmlString implements PipeTransform {
  transform(value: string): string {
    const tempElement: HTMLDivElement = document.createElement('div');
    tempElement.innerHTML = value;
    return tempElement.innerText;
  }
}

export type GroupIndex = number;
